export enum CurrentEntryPoint {
    ANDROID2 = 'android2',
    DESKTOP = 'desktop',
    DESKTOP2 = 'desktop2',
    FB = 'fb',
    FB2 = 'fb2',
    IOS2 = 'ios2',
    SITE = 'site',
    SITE2 = 'site2',
    STEAM2 = 'steam2',
}
